import { usePlaidLink, PlaidLinkError } from "react-plaid-link";
import { useState, useEffect } from "react";
import { useGeneratePlaidToken, Mode } from "./useGeneratePlaidToken";

interface UsePlaidModalProps {
  onSubmit: (publicToken: string) => void;
  onError?: (error: Error | PlaidLinkError) => void;
  mode: Mode;
}

const usePlaidModal = ({ onSubmit, mode }: UsePlaidModalProps) => {
  const [plaidError, setPlaidError] = useState<Error | null>(null);
  const { mutateAsync, isPending } = useGeneratePlaidToken(mode);
  const [token, setToken] = useState<string | null>(null);

  const { open, ready } = usePlaidLink({
    token: token,
    onSuccess: (publicToken: string) => {
      onSubmit(publicToken);
    },
    onExit: (err) => {
      if (err != null) {
        throw err;
      }
      setToken(null);
    },
  });

  const openPlaidModal = async () => {
    try {
      const data = await mutateAsync();
      setToken(data?.link_session_token);
    } catch (err) {
      window.scrollTo(0, 0);
      setPlaidError(err as Error);
    }
  };

  useEffect(() => {
    if (token && ready) {
      open();
    }
  }, [token, ready, open]);

  return { openPlaidModal, isPlaidModalLoading: isPending, plaidError };
};

export default usePlaidModal;
